var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWidth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61222 15L1.78835 4.81818H3.40412L5.38778 12.7031H5.48224L7.54545 4.81818H9.14631L11.2095 12.7081H11.304L13.2827 4.81818H14.9034L12.0746 15H10.5284L8.38565 7.37358H8.30611L6.16335 15H4.61222ZM16.1733 13.7372C15.9015 13.7372 15.6679 13.6411 15.4723 13.4489C15.2768 13.2533 15.179 13.018 15.179 12.7429C15.179 12.4711 15.2768 12.2391 15.4723 12.0469C15.6679 11.8513 15.9015 11.7536 16.1733 11.7536C16.4451 11.7536 16.6787 11.8513 16.8743 12.0469C17.0698 12.2391 17.1676 12.4711 17.1676 12.7429C17.1676 12.9252 17.1212 13.0926 17.0284 13.245C16.9389 13.3942 16.8196 13.5135 16.6705 13.603C16.5213 13.6925 16.3556 13.7372 16.1733 13.7372ZM16.1733 8.63636C15.9015 8.63636 15.6679 8.54025 15.4723 8.34801C15.2768 8.15246 15.179 7.91714 15.179 7.64205C15.179 7.37027 15.2768 7.13826 15.4723 6.94602C15.6679 6.75047 15.9015 6.6527 16.1733 6.6527C16.4451 6.6527 16.6787 6.75047 16.8743 6.94602C17.0698 7.13826 17.1676 7.37027 17.1676 7.64205C17.1676 7.82434 17.1212 7.99171 17.0284 8.14418C16.9389 8.29332 16.8196 8.41264 16.6705 8.50213C16.5213 8.59162 16.3556 8.63636 16.1733 8.63636Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWidth);
export default ForwardRef;